import { trendingKeywords } from "@/mocks/articles";

export default function TrendingTicker() {
  const loop = [...trendingKeywords, ...trendingKeywords];

  return (
    <section className="bg-accent-600 text-background-50" aria-label="热词追踪">
      <div className="mx-auto flex w-full max-w-[1400px] items-center gap-4 px-4 py-2.5 md:px-6">
        <span className="flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-bold">
          <i className="ri-fire-fill" aria-hidden="true"></i>
          热词追踪
        </span>
        <div className="relative h-6 flex-1 overflow-hidden">
          <div className="gw-marquee-track">
            {loop.map((word, index) => (
              <span key={`${word}-${index}`} className="mx-4 text-sm text-background-100">
                <i className="ri-price-tag-3-line mr-1.5" aria-hidden="true"></i>
                {word}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}